import styled from "styled-components";

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;

  .pagination {
    display: flex;
    padding-left: 0;
    list-style: none;

    > :last-child {
      border-right: 1px solid #d4e3e9;
    }
  }

  .page-link {
    display: flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .page-item {
    color: #2f4264;
    border-top: 1px solid #d4e3e9;
    border-bottom: 1px solid #d4e3e9;
    border-left: 1px solid #d4e3e9;
    cursor: pointer;
    background-color: #fff;

    &:hover {
      background-color: #d4e3e9;
    }
  }

  .active {
    background-color: #d4e3e9;
    font-weight: bold;
  }
`